module.exports = __webpack_public_path__ + "static/img/dark_image-min.d8f9e67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/min/dark_image-min.jpg
// module id = LUsZ
// module chunks = 1